import React from 'react';
import { PillButton, CancelButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import './ResumePlanModal.css';

export const ResumePlanModal = ({ isShowing, handleResumeSubscription, onClose }) => {
  return (
    <Modal crossColor="white" isShowing={isShowing} customClass="resumeModal" onClose={onClose}>
      <div className="wrapper">
        <div className="header">Start watching Fox Nation Again</div>
        <div className="content">
          <div className="message">
            Jump back into all the shows, movies and documentaries. To resume your subscription today, select OK.
          </div>
          <PillButton text="OK" onClick={handleResumeSubscription} />
          <CancelButton onClick={onClose} text="Cancel" className="blackLink" />
        </div>
      </div>
    </Modal>
  );
};
